import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import * as cls from "./modalReport.module.scss";
import { StudentService } from "../studentService";
import { useSelector } from "react-redux";
import {
  Button,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
const service = StudentService;

function ModalReport({ planningId, setIsShowModal }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [data, setData] = useState(null);
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const handleClose = () => {
    setIsShowModal(false);
  };
  useEffect(() => {
    if (planningId) {
      const request = {
        method: "post",
        path: "/resources/antiplagiat/self_check/report/json",
        data: {
          access_token: access_token,
          study_contract_id: contractId,
          creative_report_id: planningId,
        },
      };
      service.send(request, setData);
    }
  }, [planningId]);
  if (!data)
    return (
      <Dialog
        fullScreen={fullScreen}
        open={true}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
      >
        {" "}
        <WidgetFrame icon="loading" title="Идет загрузка" />;
      </Dialog>
    );
  return (
    <Dialog
      fullScreen={fullScreen}
      open={true}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      classes={{ paper: cls.dialog_paper }}
    >
      <DialogContent>
        <p dangerouslySetInnerHTML={{ __html: data.student_report }}></p>
      </DialogContent>
      <div>
        <DialogActions classes={{ paper: cls.dialogContnent }}>
          <Button type="primary" onClick={handleClose}>
            Закрыть
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default ModalReport;
